import styled, { css } from 'styled-components';
import { flexColumn, flexCenterVertical } from '@stylesheets/helpers';

export const HistoryContainer = styled.div`
  ${flexColumn};
`;

export const EmptyState = styled.div`
  ${({ theme: { spacing, font, colors } }) => css`
    padding: ${spacing.level4} ${spacing.level5};
    font-size: ${font.bodyMedium.fontSize};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const LoadingState = styled.div`
  ${({ theme: { spacing, font, colors } }) => css`
    padding: ${spacing.level4} ${spacing.level5};
    font-size: ${font.bodyMedium.fontSize};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const PaginationRow = styled.div`
  ${flexCenterVertical};
  justify-content: center;

  ${({ theme: { spacing, font, colors } }) => css`
    gap: ${spacing.level4};
    padding: ${spacing.level4} 0;
    font-size: ${font.bodySmall.fontSize};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const StandaloneRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  ${({ theme: { spacing, colors } }) => css`
    gap: ${spacing.level2};
    padding: ${spacing.level3} ${spacing.level4};
    border-bottom: 1px solid ${colors.surfaceContainerHighest};

    &:last-child {
      border-bottom: none;
    }
  `}
`;

export const StandaloneLeft = styled.div`
  ${flexColumn};
  gap: 2px;
`;

export const StandaloneType = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    font-weight: ${font.labelLarge.fontWeight};
    color: ${colors.onSurface};
  `}
`;

export const StandaloneDate = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.labelSmall.fontSize};
    line-height: ${font.labelSmall.lineHeight};
    color: ${colors.outline};
  `}
`;

export const StandaloneAmount = styled.span<{ $positive?: boolean }>`
  text-align: right;
  flex-shrink: 0;

  ${({ theme: { font, colors }, $positive }) => css`
    font-size: ${font.bodyMedium.fontSize};
    font-weight: ${font.labelLarge.fontWeight};
    color: ${$positive ? colors.primary : colors.onSurface};
  `}
`;
